import React from "react";
import { TimePicker } from ".";
import moment from "moment";

interface Props {
  value: moment.Moment
  onChange: (date: moment.Moment, submit: boolean) => void
  autoFocus?: boolean
}

const OptionalTimePicker = (props: Props) => {

  return <TimePicker
    canBeEmpty
    value={props.value}
    onChange={props.onChange}
    autoFocus={props.autoFocus}
  />
};

export default OptionalTimePicker;